import { Fragment, useEffect, useState, useRef } from 'react';
import { Button, Layout, Card, Space, Form, Input, Skeleton, Tooltip, Row, Col, Tabs } from 'antd';
import { Link, useNavigate, useLocation, useParams } from 'react-router-dom';
import DataTab from './DataTab';
import './index.less';
import PageHeader from '@components/PageHeader/PageHeader';

const DetailsSurvey = () => {
    useEffect(() => {
        document.title = '数据详情-医调研';
    }, []);

    const location = useLocation();
    const navigate = useNavigate();
    const [filObj, setFilObj] = useState({
        phone: '',
        durationBegin: '',
        durationEnd: '',
        submittedBegin: '',
        submittedEnd: '',
        channelId: null,
    });

    const goChart = () => {
        navigate(`/wj/surveys/${location.state.id}/charts`, { state: location.state });
    };
    const goCostomReport = () => {
        navigate(`/wj/surveys/${location.state.id}/customreport`, { state: location.state });
    };
    return (
        <div className="survey_charts_wrap">
            <PageHeader breadcrumb={[]}>
                <Link to="/wj/surveys" className="back">
                    <i className="bi bi-chevron-left"></i>
                </Link>
                {location.state.name}
            </PageHeader>
            <div className="main_content">
                <div className="left">
                    <p className="menu-pointer" onClick={goChart}>
                        <i className="bi bi-graph-up"></i> &nbsp;&nbsp;统计图表
                    </p>
                    <p className="active menu-pointer">
                        <i className="bi bi-archive"></i>
                        &nbsp;&nbsp;数据详情
                    </p>
                    <p className="menu-pointer" onClick={goCostomReport}>
                        <i className="bi bi-file-text"></i>
                        &nbsp;&nbsp;调研报告
                    </p>
                </div>
                <div className="right">
                    <div className="details">
                        <DataTab filObj={filObj} setFilObj={setFilObj} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DetailsSurvey;
